export default __webpack_public_path__ + "static/media/bobike40000.64519f70.png";